<template>
  <el-container id="aUser">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_auth" ref='select1' @click.native="getAuthority()"
                       @visible-change='show_change1' @change="getUser()"
                       clearable filterable placeholder="全部角色"
                       style="width:10vw;">
              <el-option
                v-for="item in li_auth"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                  <!--@click.native="show_table(httpData,roomData)"-->
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:0.5vw;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_status" ref='select2' @change="getUser()"
                       @visible-change='show_change2'
                       clearable filterable placeholder="全部状态"
                       style="width:10vw;">
              <el-option
                v-for="item in li_status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </span>
          <!--          <span style="margin-left:0.5vw;color: #ffffff; font-size: 13px">
                      <el-select v-model="edi_wx" ref='select3'
                                 @visible-change='show_change3'
                                 clearable filterable placeholder="是否关联微信"
                                 style="width:10vw;">
                        <el-option
                          v-for="item in li_wx"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </span>-->
          <!--      @keyup.enter.native="init_View()"
                    @clear="init_View()"-->
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入账号查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              clearable
              @change="getUser()"
              v-model="scan_user">
            </el-input>
          </span>
          <el-button @click="addUser" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增人员
          </el-button>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column v-if="d.key!=='状态'" :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
            <el-table-column v-else label="状态" width="200">
              <template v-slot="scope">
                <el-switch
                  v-model="scope.row[d.val]"
                  active-color="#13ce66"
                  inactive-color="#f4f4f4"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="changeUser(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
          </div>
          <el-table-column
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="change_dvc(scope.row)" type="text" size="small" icon="el-icon-edit"
                         style="color:#72767b;font-size: 16px"/>
              <el-button @click="del_user(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right; margin-right:0.5vw;margin-top:5px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page="page"
          :page-sizes="[10,20,30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
      title="删除提示"
      :visible.sync="daiDelUser"
      width="30%">
      <span>确定删除该人员吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelUser = false">取 消</el-button>
        <el-button type="primary" @click=delUser()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"aUser",
  data(){
    return {
      h_text:"人员管理",
      li_h_text:[
        {"text":"管理设置","colour":"#B7B7B7","pages":""}
      ],
      edi_auth:[],
      li_auth:[], /*角色列表*/
      li_user:[],
      scan_user:"",
      page:1,
      pageSize:10,
      total:0,
      autPage:1,
      autPageSize:10,
      autTotal:10,
      maxHeight:window.innerHeight - 225,
      defHead:[
        //{'key':"序号",'val':"item","w":"200px"},
        {'key':"账号",'val':"userName","w":"auto"},
        {'key':"用户名称",'val':"nickName","w":"auto"},
        {'key':"管理角色",'val':"authName","w":"auto"},
        {'key':"状态",'val':"userState","w":"auto"}
      ],
      tabData:[],
      edi_status:"",
      li_status:[
        {
          value:'1',
          label:'启用'
        },
        {
          value:'0',
          label:'禁用'
        }
      ],
      edi_wx:"",
      li_wx:[
        {
          value:'是',
          label:'是'
        },
        {
          value:'否',
          label:'否'
        }
      ],
      post_head:{},
      daiDelUser:false
    };
  },
  methods:{ /*方法存放*/
    change_dvc(row){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/glUserSon',
        query:{
          key:'changeUser',
          id:row.id,
          userName:row.userName,
          nickName:row.nickName,
          authorityId:row.authorityId
        }
      });
    },
    addUser(){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/glUserSon',
        query:{key:'addUser'}
      });
    },
    changeUser(row){
      const params = {
        'id':row.id,
        'UserName':row.userName,
        'projectId':localStorage.getItem("projectId")
      };
      if(row.userState) {
        params['userStateId'] = 3;
      } else {
        params['userStateId'] = 5;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.setSysUserInfo,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    del_user(row){
      this.id = row.id;
      this.daiDelUser = true;
    },
    delUser(){
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.deleteSysUser,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelUser = false;
        this.getUser();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("删除失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}){ /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getUser();
    },
    handleCurrentChange1(val){
      this.page = val;
      this.getUser();
    },
    show_change1(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item){
      if(item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item){
      if(item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    init_View(){
      let data = this.li_user;
      let li_d = [];
      let j = 1;
      let l = [];
      for(let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          userName:data[i]['userName'], /*账号*/
          nickName:data[i]['nickName'], /*用户别名*/
          userState:data[i]['userState'],
          userStateId:data[i]['userStateId'],
          authorityId:data[i]['authorityId'],  /*角色id*/
          authName:data[i]['authority']["authorityName"]  /*角色id*/
        };
        d["userState"] = d["userStateId"] === 3; /*启用状态*/
        li_d.push(d);
        j += 1;
      }
      // this.li_auth = l
      this.tabData = li_d;
    },
    getAuthority(){
      if(this.autPage * this.autPageSize > this.autTotal) {
        return;
      }
      const params = {
        'page':this.autPage,
        'pageSize':this.autPageSize
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAuthorityList,params,headers).then(res => {
        console.log(res.data.data);
        this.autTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_auth;
        for(let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['authorityId'],
            label:data[i]['authorityName']
          };
          l.push(d);
        }
        this.li_auth = l;
        this.autPage += 1;
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取角色信息失败");
        }
      });
    },
    getUser(){
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if(this.edi_auth) {
        params["authorityId"] = this.edi_auth; /*角色id*/
      }
      if(this.edi_status !== null) {
        params["userStateId"] = this.edi_status; /*是否启用*/
      }
      if(this.scan_user) {
        params["userName"] = this.scan_user; /*用户查找*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getSysUserList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_user = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取用户信息失败");
        }
      });
    },
    scolling(){ /*下拉更新*/
      let e = this.$refs.select1.$refs.scrollbar.$refs.wrap;
      if(this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop <= e.clientHeight;
      if(loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore(){
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getAuthority();
    }
  },
  mounted(){ /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.$refs.select1.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
    this.getUser();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData(){
      return this.tabData.filter(item => {
        this.state = true;
        // if (this.edi_auth && item.authorityId !== this.edi_auth) {
        //   this.state = false
        // }
        // if (this.scan_user && !item.userName.includes(this.scan_user)) {
        //   this.state = false
        // }
        // if (this.edi_status) {
        //   if (this.edi_status.includes("启用")) {
        //     if (!item.userState) {
        //       this.state = false
        //     }
        //   } else {
        //     if (item.userState) {
        //       this.state = false
        //     }
        //   }
        // }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#aUser {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/gls/glUser.vue